<template>
    <div v-if="store">
        <b-row>
            <b-col md="12" lg="12">
                <b-card>
                    <div class="card-text">
                        <b-row>
                            <b-col md="6" lg="4">
                                <h5>Nombre</h5>
                                <label for="">{{store.name}}</label>
                                <hr>
                            </b-col>
                            <b-col md="6" lg="4">
                                <h5>Documento</h5>
                                <label for="">{{store.document}}</label>
                                <hr>
                            </b-col>
                            <b-col md="6" lg="4">
                                <h5>Dirección</h5>
                                <label for="">{{store.address}}</label>
                                <hr>
                            </b-col>
                            <b-col md="6" lg="4">
                                <h5>Sitio web</h5>
                                <label for="">{{store.website}}</label>
                                <hr>
                            </b-col>
                            <b-col md="6" lg="4">
                                <h5>Cliente cercano</h5>
                                <label for="">{{store.client.name}}</label>
                                <hr>
                            </b-col>
                            <b-col md="6" lg="4">
                                <h5>Sede</h5>
                                <label for="">{{store.venue.name}}</label>
                                <hr>
                            </b-col>
                            <b-col md="12" lg="6">
                                <h5>Horario de atención</h5>
                                <label for="">{{store.availability}}</label>
                                <hr>
                            </b-col>
                            
                            <b-col md="12" lg="6">
                                <h5>Categorias</h5>
                                <b-badge pill v-for="category in store.store_categories" :key="category.id" variant="info">
                                    {{category.name}} 
                                </b-badge>
                                <hr>
                            </b-col>
                            <b-col md="12" lg="6">
                                <b-card title="Información contacto principal">
                                    <div class="card-text">
                                        <b-row>
                                            <b-col md="6" lg="6">
                                                <h5>Nombre</h5>
                                                <label for="">{{store.primary_contact_name}}</label>
                                                <hr>
                                            </b-col>
                                            <b-col md="6" lg="6">
                                                <h5>Teléfono</h5>
                                                <label for="">{{store.primary_contact_phone}}</label>
                                                <hr>
                                            </b-col>
                                            <b-col md="6" lg="6">
                                                <h5>E-mail</h5>
                                                <label for="">{{store.primary_contact_email}}</label>
                                                <hr>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col md="12" lg="6">
                                <b-card title="Ubicación">
                                    <div class="card-text">
                                        <b-row>
                                            <b-col md="6" lg="4">
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        store: {
            required: true
        }
    }
}
</script>
